var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Collection, Complex } from '@syncfusion/ej2-base';
import { Container } from '../core/containers/container';
import { Node } from '../objects/node';
import { Connector } from '../objects/connector';
import { Point } from '../primitives/point';
import { Size } from '../primitives/size';
import { SelectorConstraints } from '../enum/enum';
import { Margin } from '../core/appearance';
/**
 * Defines the behavior of selector
 */
var UserHandle = /** @class */ (function (_super) {
    __extends(UserHandle, _super);
    function UserHandle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property('')
    ], UserHandle.prototype, "name", void 0);
    __decorate([
        Property('')
    ], UserHandle.prototype, "pathData", void 0);
    __decorate([
        Property('#000000')
    ], UserHandle.prototype, "backgroundColor", void 0);
    __decorate([
        Property('top')
    ], UserHandle.prototype, "side", void 0);
    __decorate([
        Property('')
    ], UserHandle.prototype, "borderColor", void 0);
    __decorate([
        Property(0.5)
    ], UserHandle.prototype, "borderWidth", void 0);
    __decorate([
        Property(25)
    ], UserHandle.prototype, "size", void 0);
    __decorate([
        Property('white')
    ], UserHandle.prototype, "pathColor", void 0);
    __decorate([
        Property(10)
    ], UserHandle.prototype, "displacement", void 0);
    __decorate([
        Property(true)
    ], UserHandle.prototype, "visible", void 0);
    __decorate([
        Property(0)
    ], UserHandle.prototype, "offset", void 0);
    __decorate([
        Complex({}, Margin)
    ], UserHandle.prototype, "margin", void 0);
    __decorate([
        Property('Center')
    ], UserHandle.prototype, "horizontalAlignment", void 0);
    __decorate([
        Property('Center')
    ], UserHandle.prototype, "verticalAlignment", void 0);
    return UserHandle;
}(ChildProperty));
export { UserHandle };
/**
 * Defines the behavior of the selected objects
 */
var Selector = /** @class */ (function (_super) {
    __extends(Selector, _super);
    function Selector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Initializes the UI of the container
     */
    Selector.prototype.init = function (diagram) {
        var container = new Container();
        container.measureChildren = false;
        var consize = new Size();
        container.children = [];
        if (this.nodes || this.connectors) {
            for (var i = 0; i < this.nodes.length; i++) {
                var node = diagram.nameTable[this.nodes[i].id];
                var wrapper = node.wrapper;
                // this.width = wrapper.actualSize.width; 
                // this.height = wrapper.actualSize.height;
                // this.rotateAngle = wrapper.rotateAngle;
                // this.offsetX = wrapper.offsetX;
                // this.offsetY = wrapper.offsetY;
                container.children.push(wrapper);
            }
            for (var j = 0; j < this.connectors.length; j++) {
                var connector = diagram.nameTable[this.connectors[j].id];
                var wrapper = connector.wrapper;
                // this.width = wrapper.actualSize.width; this.height = wrapper.actualSize.height;
                // this.rotateAngle = wrapper.rotateAngle; this.offsetX = wrapper.offsetX;
                // this.offsetY = wrapper.offsetY;
                container.children.push(wrapper);
            }
        }
        this.wrapper = container;
        return container;
    };
    __decorate([
        Property(null)
    ], Selector.prototype, "wrapper", void 0);
    __decorate([
        Collection([], Node)
    ], Selector.prototype, "nodes", void 0);
    __decorate([
        Collection([], Connector)
    ], Selector.prototype, "connectors", void 0);
    __decorate([
        Property()
    ], Selector.prototype, "width", void 0);
    __decorate([
        Property()
    ], Selector.prototype, "height", void 0);
    __decorate([
        Property(0)
    ], Selector.prototype, "rotateAngle", void 0);
    __decorate([
        Property(0)
    ], Selector.prototype, "offsetX", void 0);
    __decorate([
        Property(0)
    ], Selector.prototype, "offsetY", void 0);
    __decorate([
        Complex({ x: 0.5, y: 0.5 }, Point)
    ], Selector.prototype, "pivot", void 0);
    __decorate([
        Property('CompleteIntersect')
    ], Selector.prototype, "rubberBandSelectionMode", void 0);
    __decorate([
        Collection([], UserHandle)
    ], Selector.prototype, "userHandles", void 0);
    __decorate([
        Property(SelectorConstraints.All)
    ], Selector.prototype, "constraints", void 0);
    return Selector;
}(ChildProperty));
export { Selector };
